/*
 * Manful — engraving cart engine (Phase 3). Mirrors assets/gift-box.js.
 *
 * Model: the engraving text/font ride the ITEM line as visible properties (Engraving, Font,
 * Lines). A hidden property _engraving_variant links the item to its charge tier (the One side
 * £10 or Both sides £20 variant of the hidden "engraving" product). recompute() is the single
 * source of truth: each charge variant's line quantity is kept equal to the number of engraved
 * units that selected that tier. Writes only on mismatch → converges, never loops.
 *
 * Coexistence with the gift box: this engine ignores BOTH charge products (it only counts items
 * that carry an Engraving property and are not themselves a charge line). Tagging happens at PDP
 * add (not in-cart), so it never races the gift box's in-cart line splits. Remove/re-add copies
 * every non-engraving property (so a gift-boxed engraved line keeps "Gift box: Yes").
 */
(function () {
  var CFG = window.MANFUL_ENGRAVING || {};
  var ONE = Number(CFG.oneSideId), BOTH = Number(CFG.bothSidesId);
  if (!ONE) { return; } // engraving charge product not resolved — do nothing

  var CHARGE = {}; CHARGE[ONE] = true; if (BOTH) { CHARGE[BOTH] = true; }
  var TIER = '_engraving_variant'; // hidden item property = chosen charge variant id
  var ENG_PROPS = ['Engraving', 'Engraving (back)', 'Font', 'Lines', '_engraving_variant'];

  var ROUTES = (window.theme && window.theme.routes) || {};
  var URL_CART = ROUTES.cart || '/cart.js';
  var URL_CHANGE = ROUTES.cartChange || '/cart/change.js';
  var URL_ADD = ROUTES.cartAdd || '/cart/add.js';

  var syncing = false, pending = false, busy = false, injecting = false;
  var observers = [], debounceTimer = null, rebuildTimer = null;

  function getCart() {
    return fetch(URL_CART + (URL_CART.indexOf('?') === -1 ? '?' : '&') + 't=' + Date.now(),
      { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin', body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }
  function rebuild() {
    clearTimeout(rebuildTimer);
    rebuildTimer = setTimeout(function () { document.dispatchEvent(new CustomEvent('cart:build')); }, 60);
  }

  // A gift-bundle engraving line carries its OWN charge (the separate "Bundle Engraving" product)
  // and is tagged _bundle_engraving. It also has an "Engraving" property, so without this guard the
  // site reconciler would add a SECOND "Engraving" charge line on top of it — the £10+£10=£20 double.
  function isEngraved(it) { return !CHARGE[it.variant_id] && it.properties && !it.properties['_bundle_engraving'] && (it.properties['Engraving'] || it.properties['Engraving (back)']); }
  function tierOf(it) {
    var v = (it.properties && it.properties[TIER]) ? Number(it.properties[TIER]) : ONE;
    return CHARGE[v] ? v : ONE;
  }
  function tally(cart) {
    var t = {}; t[ONE] = 0; if (BOTH) { t[BOTH] = 0; }
    (cart.items || []).forEach(function (it) { if (isEngraved(it)) { var v = tierOf(it); t[v] = (t[v] || 0) + it.quantity; } });
    return t;
  }
  function chargeLine(cart, vid) {
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) { if (items[i].variant_id === vid) { return items[i]; } }
    return null;
  }

  // Single source of truth: each charge variant qty == engraved units at that tier. Writes only on mismatch.
  function recompute() {
    if (syncing) { pending = true; return Promise.resolve(false); }
    syncing = true;
    return getCart().then(function (cart) {
      var t = tally(cart);
      var ids = Object.keys(t).map(Number);
      var changed = false;
      return ids.reduce(function (chain, vid) {
        return chain.then(function () {
          var want = t[vid] || 0, line = chargeLine(cart, vid), have = line ? line.quantity : 0;
          if (want === have) { return; }
          changed = true;
          if (want > 0 && !line) { return post(URL_ADD, { items: [{ id: vid, quantity: want }] }); }
          if (line) { return post(URL_CHANGE, { id: line.key, quantity: want }); } // change by KEY (variant-id 400s here)
        });
      }, Promise.resolve()).then(function () { return changed; });
    }).then(function (changed) {
      syncing = false;
      if (changed) { rebuild(); }
      if (pending) { pending = false; return recompute(); }
      return changed;
    }).catch(function (e) {
      syncing = false;
      if (window.console) { console.warn('[engraving] recompute failed', e); }
      if (pending) { pending = false; return recompute(); }
      return false;
    });
  }

  // change.js can't remove properties → remove the line and re-add the piece without engraving props,
  // carrying every other property (incl. "Gift box: Yes") to the new line. Then reconcile the charge.
  function removeEngraving(key) {
    if (busy) { return Promise.resolve(); }
    busy = true;
    return getCart().then(function (cart) {
      var item = null;
      (cart.items || []).forEach(function (it) { if (it.key === key) { item = it; } });
      if (!item) { return; }
      var props = {};
      if (item.properties) { for (var k in item.properties) { if (item.properties.hasOwnProperty(k) && ENG_PROPS.indexOf(k) === -1) { props[k] = item.properties[k]; } } }
      var ai = { id: item.variant_id, quantity: item.quantity };
      if (Object.keys(props).length) { ai.properties = props; }
      if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) { ai.selling_plan = item.selling_plan_allocation.selling_plan.id; }
      return post(URL_CHANGE, { id: key, quantity: 0 })
        .then(function () { return post(URL_ADD, { items: [ai] }); })
        .then(function () { rebuild(); return recompute(); });
    }).then(function (r) { busy = false; return r; }, function (e) {
      busy = false; if (window.console) { console.warn('[engraving] removeEngraving failed', e); }
    });
  }

  // INJECT-ONLY: hide the charge lines, add a "Remove engraving" control to engraved lines. Never writes.
  function injectCart(cart) {
    var byKey = {}, feeByTier = {};
    (cart.items || []).forEach(function (it) { byKey[it.key] = it; if (CHARGE[it.variant_id]) { feeByTier[it.variant_id] = it.price; } });
    var cur = cart.currency || 'GBP';
    function fmt(cents) { try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100); } catch (e) { return (cents / 100).toFixed(2); } }

    var nodes = document.querySelectorAll('.cart__item[data-key]');
    Array.prototype.forEach.call(nodes, function (node) {
      var key = node.getAttribute('data-key'), it = byKey[key];
      if (!it) { return; }
      if (CHARGE[it.variant_id]) { node.style.display = 'none'; return; } // hide the fee line — folded into the item price
      if (!isEngraved(it)) { return; }

      // Fold the engraving fee into this item's DISPLAYED price (Basic plan can't merge it for real,
      // so we hide the fee line and show ring + engraving as one figure; checkout still itemises).
      var fee = feeByTier[tierOf(it)] || 0;
      if (fee) {
        var priceEl = node.querySelector('.cart__item-price-col .cart__discount')
          || node.querySelector('.cart__item-price-col .cart__price:not(.cart__price--strikethrough)');
        // Idempotent: only write when the value changes. Rewriting every pass is a DOM mutation
        // the gift-box observer would see → it re-injects → our observer re-fires → infinite ping-pong.
        if (priceEl) { var want = fmt(it.final_price + fee); if (priceEl.textContent.trim() !== want) { priceEl.textContent = want; } }
      }

      if (!node.querySelector('.mf-engrave-remove')) {
        var det = node.querySelector('.cart__item-details') || node;
        var w = document.createElement('div');
        w.className = 'mf-engrave-remove';
        w.innerHTML = '<button type="button" class="mf-engrave-remove__link">Remove engraving</button>';
        det.appendChild(w);
        w.querySelector('button').addEventListener('click', function () { this.disabled = true; removeEngraving(key); });
      }
    });
  }

  function disconnectObservers() { observers.forEach(function (o) { o.disconnect(); }); }
  function reconnectObservers() {
    observers.forEach(function (o) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-products]'), function (el) { o.observe(el, { childList: true, subtree: true }); });
    });
  }
  function injectPass() {
    if (injecting) { return; }
    getCart().then(function (cart) { injecting = true; disconnectObservers(); injectCart(cart); injecting = false; reconnectObservers(); });
  }
  function scheduleInject() { clearTimeout(debounceTimer); debounceTimer = setTimeout(injectPass, 150); }
  function startObserving() {
    var targets = document.querySelectorAll('[data-products]');
    if (!targets.length) { return; }
    var mo = new MutationObserver(function () { if (!injecting) { scheduleInject(); } });
    observers.push(mo);
    Array.prototype.forEach.call(targets, function (el) { mo.observe(el, { childList: true, subtree: true }); });
  }

  // Reconcile on every user-initiated cart change. This Impulse theme fires `ajaxProduct:added`
  // on add-to-cart (NOT cart:updated — verified on the storefront), plus cart:updated on
  // qty/remove edits. recompute()'s own writes use raw fetch (no theme events) so this never loops.
  document.addEventListener('ajaxProduct:added', function () { recompute(); });
  document.addEventListener('cart:updated', function () { recompute(); });
  function init() { startObserving(); injectPass(); recompute(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
